import "../../../../../../create-protocol/style.less";
import { InputNumber, Row, Col, Flex, Tooltip } from "antd";
import { formatTranslation } from "../../../../../../../shared/utils/translationUtils";
import { useTranslation } from "react-i18next";
import { type ReactElement, useState } from "react";
import { CpInstruction } from "./CpInstruction";
import infoIcon from "../../../../../../../assets/images/info.svg";
import { restrictToTwoDecimals } from "../../../../../utils";
interface TankMixRateSectionProps {
  loading: boolean;
  formData: any;
  pIndex: number;
  item?: any;
  handleChangeFormData: (data: any) => void;
}

export const TankMixRateSection = ({
  loading,
  formData,
  pIndex,
  item = {},
  handleChangeFormData,
}: TankMixRateSectionProps): ReactElement => {
  const { t } = useTranslation();
  const [volumeError, setVolumeError] = useState(false);
  const handleChange = (key: string, value: string): any => {
    const currentTankMixRate = formData[pIndex]?.tank_mix_rate ?? {};
    const min = key === "min" ? value : currentTankMixRate.min;
    const max = key === "max" ? value : currentTankMixRate.max;
    const isMinEmpty = min === "" || min === null || min === undefined;
    const isMaxEmpty = max === "" || max === null || max === undefined;
    if (isMinEmpty || isMaxEmpty) {
      setVolumeError(false);
    } else {
      const minNum = Number(min);
      const maxNum = Number(max);
      if (!isNaN(minNum) && !isNaN(maxNum) && minNum > maxNum) {
        setVolumeError(true);
      } else {
        setVolumeError(false);
      }
    }

    formData[pIndex].tank_mix_rate = { ...item, [key]: value };
    handleChangeFormData([...formData]);
  };
  return (
    <div className="tank-mix-rate-container">
      <Flex gap={8} align="center">
        <h3 className="config-header">
          {formatTranslation(
            t("createProtocol.products.biologicals.product.tankMixRate")
          )}
        </h3>
        <Tooltip
          placement="right"
          title={formatTranslation(t("configure.minimum.max.tank.volume"))}
        >
          <img src={infoIcon} alt="info-icon" className="tank-mix-rate-info" />
        </Tooltip>
      </Flex>
      <Row gutter={16}>
        <Col span={12}>
          <div className="min-max-rates-inputs">
            <div
              className="input-rate-label"
              style={{ marginBottom: "8px", fontWeight: 500 }}
            >
              {formatTranslation(
                t("createProtocol.products.biologicals.product.minLabel")
              )}
              <span style={{ color: "red" }}> *</span>
            </div>
            <InputNumber
              min={0.01}
              step={0.01}
              precision={2}
              disabled={loading}
              value={item.min ?? null}
              onChange={(minValue: any) => {
                handleChange("min", minValue);
              }}
              onKeyDown={restrictToTwoDecimals}
              style={{ width: "100%" }}
              className="input-number"
              size="large"
              status={
                item.min && item.max && item.min > item.max
                  ? "error"
                  : undefined
              }
            />
          </div>
        </Col>
        <Col span={12}>
          <div className="min-max-rates-inputs">
            <div
              className="input-rate-label"
              style={{ marginBottom: "8px", fontWeight: 500 }}
            >
              {formatTranslation(
                t("createProtocol.products.biologicals.product.maxLabel")
              )}
              <span style={{ color: "red" }}> *</span>
            </div>
            <InputNumber
              min={0.01}
              step={0.01}
              precision={2}
              value={item?.max ?? null}
              disabled={loading}
              onChange={(maxValue: any) => {
                handleChange("max", maxValue);
              }}
              onKeyDown={restrictToTwoDecimals}
              style={{ width: "100%" }}
              className="input-number"
              size="large"
              status={
                item.min && item.max && item.max < item.min
                  ? "error"
                  : undefined
              }
            />
          </div>
        </Col>
      </Row>
      {volumeError && (
        <div>
          <span className="error-message">
            {formatTranslation(
              t("createProtocol.products.nutrients.minLowerThanMaxRate.error")
            )}
          </span>
          <span className="error-message-right">
            {formatTranslation(
              t("createProtocol.products.nutrients.maxHigherThanMinRate.error")
            )}
          </span>
        </div>
      )}
      <CpInstruction
        formData={formData}
        pIndex={pIndex}
        item={formData[pIndex] ?? {}}
        loading={loading}
        handleChangeFormData={handleChangeFormData}
      />
    </div>
  );
};
